module.exports = __webpack_public_path__ + "static/media/google-logo.58ca3456.svg";